import { React, useEffect, useState, useContext } from "react";
import { MyContextProvider } from "../../../App"
import axios from "axios";
import { API_URL } from "../../../Constant";
import { GlobalLoading, showLoading } from "react-global-loading";
import { ToastContainer, toast } from "react-toastify";
import { changeDateFormat} from "../../../Custom/Custom";
import { generateASIBlockReport } from "../../../Custom/ASIReport/PendencyReport/ExportaPendencyReportExcel";
import messages from '../../../assets/Messages.json';
import asiTitle from '../../../asi.json';
import asiInputTitle from '../../../titles.json';


function ASIBlock() {

    const [year,setYear]=useState([]);
    const [yearName, setYearName] = useState("");
    const [blockName, setblockName] = useState("");
    const token = useContext(MyContextProvider).token;
    const storedLanguage = localStorage.getItem('language');
    const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };


useEffect(() => {
   getSurveyYears();
}, []);
      
    

 
const getSurveyYears=async()=>{
  showLoading(true)
     try {
        const response = await axios.get(`${API_URL}api/asi/surveyYearList`, config);
        const allYear = response.data;
        if (allYear.status) {
            setYear(allYear.data.surveyYearList)
            showLoading(false);
        }
  } catch (error) {
     console.error(error);
     showLoading(false);
  }finally{
     showLoading(false);
  }

}



// Handle on change Event ********
 const handleDropdownChange = (e) => {
    
    switch (e.target.name) {
        case "yearName":
        setYearName(e.target.value);
        break;
        case "blockName":
        setblockName(e.target.value);
        break;
    default:
        console.log("switch case are not match");
        break;
    }
 };

 // Function to generate Excel file using mapped data
const handleGenerateExcel = async () => {
    if (!yearName) {
        toast.error("Please select a Survey Year", messages.COLOR_RED);
        return;
      }
    if (!blockName) {
        toast.error("Please select a Block Type", messages.COLOR_RED);
        return;
      }
  
  try{
  
      let postData = {
          survey_year: yearName,
          block_type:blockName
        }
         showLoading(true);
         const response = await axios.post(`${API_URL}api/asi/reports/asiBlockReports`, postData, config);

           const allData = response.data;
           if(allData.status){
            const rawRows = Array.isArray(allData?.data?.asiFilledReport)
              ? allData.data.asiFilledReport
              : [];
            // Requirement: Excel me sirf STATUS_FLAG === "8" wale rows export hon
            const filteredRows = rawRows.filter(
              (r) =>
                String(r?.STATUS_FLAG ?? r?.statusFlag ?? "") === "8"
            );

            if (filteredRows.length === 0) {
              const msg =
                allData?.message ||
                "Data found for the specified parameters";
              toast.error(
                msg,
                messages.COLOR_RED
              );
              return;
            }

            downloadReport(filteredRows,blockName,yearName)
           }else{
            toast.error(`Data is not found for ${blockName}`, messages.COLOR_RED);
           }
       
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
  } finally {
    showLoading(false);
  }
};



const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return value;
    return Number(value).toFixed(2);
  };


  
const downloadReport=(allData,blockName,yearName)=>{
  
    let excelRowData='';
    let excelObjectData='';

  switch(blockName){
        // customize Block A Data
        case 'ASI_BLOCKA' :    
            excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.PSL_NO,
                item.SCHEME_CODE,
                item.NIC_CODE_PERRETURN,
                item.DISTRICT_CODE,
                item.RO_SRO_CODE,
                item.SECTOR,
                item.NUMBER_OF_UNITS,
                item.STATUS_OF_UNITCODE,
                item.DISTRICT_NAME,
                item.DIVISION_NAME,
                item.REGION_CODE,
                item.REGION_NAME,
                item.NIC_CODE_PERFRAME,
                item.DIVISION_CODE,
                
              ]);

              excelObjectData = {
               fileName: 'ASIBlockA',
               reportType: 'ASIBlockA',
               fileType: 'xls',
               sheetName: 'SubASIBlockA',
               firstRowMergeCells: "A1:P1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:P2",
               secondRowText: `ASIBlockA Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR', 
                  'PSL_NO',
                  'SCHEME_CODE',
                  'NIC_CODE_PERRETURN',
                  'DISTRICT_CODE',
                  'RO_SRO_CODE',
                  'SECTOR',
                  "NUMBER_OF_UNITS",
                  "STATUS_OF_UNITCODE",
                  "DISTRICT_NAME",
                  "DIVISION_NAME",
                  "REGION_CODE",
                  "REGION_NAME",
                  "NIC_CODE_PERFRAME",
                  "DIVISION_CODE",
                 
            ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;

         // customize Block B Data
        case 'ASI_BLOCKB' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ORGANIZATION_CODE,
                item.OWNERSHIP_CODE,
                item.ISO_CERTIFICATION,
                item.YEAR_INITIAL_PRODUCTION,
                item.ACCOUNTING_YEAR,
                item.NUMBER_MONTHSOF_OPERATION,
                item.COMPUTERIZED_ACCOUNTING,
                item.ASI_DATA_COMPUTER_MEDIA,
 
                
              ]);
           excelObjectData = {
               fileName: 'ASIBlockB',
               reportType: 'ASIBlockB',
               fileType: 'xls',
               sheetName: 'SubASIBlockB',
               firstRowMergeCells: "A1:J1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:J2",
               secondRowText: `ASIBlockB Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR', 
                  'ORGANIZATION_CODE',
                  'OWNERSHIP_CODE',
                  'ISO_CERTIFICATION',
                  'YEAR_INITIAL_PRODUCTION',
                  'ACCOUNTING_YEAR',
                  'NUMBER_MONTHSOF_OPERATION',
                  'COMPUTERIZED_ACCOUNTING',
                  'ASI_DATA_COMPUTER_MEDIA',
                
                 
            ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;

         // customize Block C Data
        case 'ASI_BLOCKC' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ASSET_CODE,
                item.ASSET_NAME,
                formatGrossValue(item.GROSS_VALUE_OPENING_ASON),
                formatGrossValue(item.ADDITION_DURING_YEAR_ACTUA),
                formatGrossValue(item.ADDITION_YEAR_REVALUATION),
                formatGrossValue(item.DEDUCTION_ADJ_DURING_YEAR),
                formatGrossValue(item.DEPRECIATION_UPTO_YRBGNG),
                formatGrossValue(item.DEPRECIATION_PROVIDED_DURIN),
                formatGrossValue(item.DEPRECIATION_ADJUSTMENT),
                formatGrossValue(item.CLOSING_TOTAL),
                formatGrossValue(item.UPTO_YEAR_END_TOTAL),
                formatGrossValue(item.OPENING_AS_DIFFERENCE),
                formatGrossValue(item.CLOSING_AS_DIFFERENCE),
               ]);
           excelObjectData = {
               fileName: 'ASIBlockC',
               reportType: 'ASIBlockC',
               fileType: 'xls',
               sheetName: 'SubASIBlockC',
               firstRowMergeCells: "A1:O1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:O2",
               secondRowText: `ASIBlockC Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ASSET_CODE',
                  'ASSET_NAME', 
                  'GROSS_VALUE_OPENING_ASON',
                  'ADDITION_DURING_YEAR_ACTUA',

                  'ADDITION_YEAR_REVALUATION',
                  'DEDUCTION_ADJ_DURING_YEAR',

                  'DEPRECIATION_UPTO_YRBGNG',
                  'DEPRECIATION_PROVIDED_DURIN',
                  'DEPRECIATION_ADJUSTMENT',
                  'CLOSING_TOTAL',
                  'UPTO_YEAR_END_TOTAL',
                  'OPENING_AS_DIFFERENCE',
                  'CLOSING_AS_DIFFERENCE',
                
                 
            ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
       
        // customize Block D Data
        case 'ASI_BLOCKD' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ITEM_CODE,
                item.ITEM_NAME,
                formatGrossValue(item.OPENING_AMOUNT),
                formatGrossValue(item.CLOSING_AMOUNT)
               ]);
           excelObjectData = {
               fileName: 'ASIBlockD',
               reportType: 'ASIBlockD',
               fileType: 'xls',
               sheetName: 'SubASIBlockD',
               firstRowMergeCells: "A1:F1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:F2",
               secondRowText: `ASIBlockD Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ITEM_CODE',
                  'ITEM_NAME', 
                  'OPENING_AMOUNT',
                  'CLOSING_AMOUNT'
                ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
      
        // customize Block E Data
        case 'ASI_BLOCKE' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.CATAGORY_ID,
                item.CATEGORY_NAME,
                item.MANUFACTURING,
                item.NONMANUFACTURING,
                item.TOTAL,
                item.AVG_NO_PERSONS_WORKED,
                item.NO_MANDAYS_PAID,
                formatGrossValue(item.WAGES_OR_SALARIES)
               ]);
           excelObjectData = {
               fileName: 'ASIBlockE',
               reportType: 'ASIBlockE',
               fileType: 'xls',
               sheetName: 'SubASIBlockE',
               firstRowMergeCells: "A1:J1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:J2",
               secondRowText: `ASIBlockE Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'CATAGORY_ID',
                  'CATEGORY_NAME', 
                  'MANUFACTURING',
                  'NONMANUFACTURING',
                  'TOTAL',
                  'AVG_NO_PERSONS_WORKED',
                  'NO_MANDAYS_PAID',
                  'WAGES_OR_SALARIES',
                ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
       
        // customize Block F Data
        case 'ASI_BLOCKF' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ITEM_CODE,
                item.itemName,
                formatGrossValue(item.EXPENDITURE)
               ]);
           excelObjectData = {
               fileName: 'ASIBlockF',
               reportType: 'ASIBlockF',
               fileType: 'xls',
               sheetName: 'SubASIBlockF',
               firstRowMergeCells: "A1:E1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:E2",
               secondRowText: `ASIBlockF Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ITEM_CODE',
                  'ITEM_NAME', 
                  'EXPENDITURE',
                 ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
        
        // customize Block G Data
        case 'ASI_BLOCKG' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ITEM_CODE,
                item.ITEM_NAME,
                formatGrossValue(item.RECIPTS)
               ]);
           excelObjectData = {
               fileName: 'ASIBlockG',
               reportType: 'ASIBlockG',
               fileType: 'xls',
               sheetName: 'SubASIBlockG',
               firstRowMergeCells: "A1:E1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:E2",
               secondRowText: `ASIBlockG Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ITEM_CODE',
                  'ITEM_NAME', 
                  'RECIPTS',
                 ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
        
        // customize Block H Data
        case 'ASI_BLOCKH' :   
           excelRowData=allData.map(item => [
                item.SRNO,
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ITEM_DESC,
                item.ITEM_CODE,
                item.UNIT_OF_QTY,
                formatGrossValue(item.QTY_CONSUMED),
                formatGrossValue(item.PURCHASE_VALUE),
                formatGrossValue(item.RATE_PER_UNIT),
                item.SAVE_ORDER_BY,
                ]);
           excelObjectData = {
               fileName: 'ASIBlockH',
               reportType: 'ASIBlockH',
               fileType: 'xls',
               sheetName: 'SubASIBlockH',
               firstRowMergeCells: "A1:J1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:J2",
               secondRowText: `ASIBlockH Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'SRNO',
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ITEM_DESC', 
                  'ITEM_CODE',
                  'UNIT_OF_QTY',
                  'QTY_CONSUMED',
                  'PURCHASE_VALUE',
                  'RATE_PER_UNIT',
                  'SAVE_ORDER_BY',
                 ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
        

        // customize Block I Data
        case 'ASI_BLOCKI' :   
           excelRowData=allData.map(item => [
                item.SRNO,
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ITEM_DESC,
                item.ITEM_CODE,
                item.UNIT_OF_QTY==='NaN' ? '' : item.UNIT_OF_QTY,
                formatGrossValue(item.QTY_CONSUMED),
                formatGrossValue(item.PURCHASE_VALUE),
                formatGrossValue(item.RATE_PER_UNIT),
                ]);
           excelObjectData = {
               fileName: 'ASIBlockI',
               reportType: 'ASIBlockI',
               fileType: 'xls',
               sheetName: 'SubASIBlockI',
               firstRowMergeCells: "A1:H1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:H2",
               secondRowText: `ASIBlockI Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'SRNO',
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ITEM_DESC', 
                  'ITEM_CODE',
                  'UNIT_OF_QTY',
                  'QTY_CONSUMED',
                  'PURCHASE_VALUE',
                  'RATE_PER_UNIT',
                 ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
        
        // customize Block J Data
        case 'ASI_BLOCKJ' :   
           excelRowData=allData.map(item => [
                item.SRNO,
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.PRODUCT_BYPRODUCT_DESC,
                item.ITEM_CODE,
                item.UNIT_OF_QTY,
                formatGrossValue(item.QTY_MANUFACTURED),
                formatGrossValue(item.QTY_SOLD),
                formatGrossValue(item.GROSS_SALE_VALUE),
                formatGrossValue(item.PERUNIT_NETSALE_VALUE),
                formatGrossValue(item.EXFACTORY_VALUE_QTY),
                item.DISTRIBUTIVE_EXPENSES_EXCISE_DUTY,
                item.DISTRIBUTIVE_EXPENSES_SALES_TAX_VAT,
                item.DISTRIBUTIVE_EXPENSES_OTHERS,
                item.DISTRIBUTIVE_EXPENSES_TOTAL,
               ]);
           excelObjectData = {
               fileName: 'ASIBlockJ',
               reportType: 'ASIBlockJ',
               fileType: 'xls',
               sheetName: 'SubASIBlockJ',
               firstRowMergeCells: "A1:O1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:O2",
               secondRowText: `ASIBlockJ Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'SRNO',
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'PRODUCT_BYPRODUCT_DESC', 
                  'ITEM_CODE',
                  'UNIT_OF_QTY',
                  'QTY_MANUFACTURED',
                  'QTY_SOLD',
                  'GROSS_SALE_VALUE',
                  'PERUNIT_NETSALE_VALUE',
                  'EXFACTORY_VALUE_QTY',
                  'DISTRIBUTIVE_EXPENSES_EXCISE_DUTY',
                  'DISTRIBUTIVE_EXPENSES_SALES_TAX_VAT',
                  'DISTRIBUTIVE_EXPENSES_OTHERS',
                  'DISTRIBUTIVE_EXPENSES_TOTAL',
                 ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
      
        // customize Block K Data
        case 'ASI_BLOCKK' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.ICT_INDICATOR_CODE,
                item.ICT_INDICATOR_NAME,
                item.CODE==='2'? 'No':item.CODE==='1'? 'Yes':'',
               ]);
           excelObjectData = {
               fileName: 'ASIBlockK',
               reportType: 'ASIBlockK',
               fileType: 'xls',
               sheetName: 'SubASIBlockK',
               firstRowMergeCells: "A1:E1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:E2",
               secondRowText: `ASIBlockK Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'ICT_INDICATOR_CODE', 
                  'ICT_INDICATOR_NAME', 
                  'CODE',
                  ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;
       
        // customize Block L Data
        case 'ASI_BLOCKL' :   
           excelRowData=allData.map(item => [
                item.DSL_NO,
                item.SURVEY_YEAR,
                item.EC_INDICATOR_CO,
                item.EC_INDICATOR_NAME,
                item.CODE==='2'? 'No':item.CODE==='1'? 'Yes':'',
                formatGrossValue(item.GVA),
                formatGrossValue(item.NVA)
               ]);
           excelObjectData = {
               fileName: 'ASIBlockL',
               reportType: 'ASIBlockL',
               fileType: 'xls',
               sheetName: 'SubASIBlockL',
               firstRowMergeCells: "A1:G1",
               firstRowExportDate:  changeDateFormat(new Date()),
               secondRowMergeCells: "A2:G2",
               secondRowText: `ASIBlockL Survey-Year(${yearName})`,
               headerEnglishColumns: [
                  'DSL_NO',
                  'SURVEY_YEAR',
                  'EC_INDICATOR_CO', 
                  'EC_INDICATOR_NAME', 
                  'CODE',
                  'GVA',
                  'NVA'
                  ],
             excelRowData:excelRowData
            };
            generateASIBlockReport(excelObjectData)
        break;


        default:
        console.log("Block is not Match");


    }

}


  return (
    <>
    <GlobalLoading />
    <ToastContainer />
    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
          <h4 className="page_heading">
          <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.ASI_BLOCK_REPORT : asiTitle.en.ASI_BLOCK_REPORT }} />
         </h4>
           <div className="row align-items-center">
              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">
                 {storedLanguage === 'hi' ? asiInputTitle.hi.SURVEY_YAER : asiInputTitle.en.SURVEY_YAER}
                  </label>
                  <select
                  name="yearName"
                  className="form-select"
                  onChange={handleDropdownChange}
                  value={yearName}
                 >
                  <option value="" disabled>
                    Select Year
                  </option>
                  
                  {year.map((yearName, index) => (
                      <option key={index} value={yearName}>
                        {yearName}-{(yearName + 1).toString().slice(2)}
                     </option>
                    ))}

                </select>
              </div>

              <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                <label className="fw-bold h6">
                  BlockType 
              </label>
                    <select
                    name="blockName"
                    className="form-select"
                    onChange={handleDropdownChange}
                    value={blockName}
                    >
                    <option value="" disabled>Select Block</option>
                    <option value="ASI_BLOCKA">BlockA</option>
                    <option value="ASI_BLOCKB">BlockB</option>
                    <option value="ASI_BLOCKC">BlockC</option>
                    <option value="ASI_BLOCKD">BlockD</option>
                    <option value="ASI_BLOCKE">BlockE</option>
                    <option value="ASI_BLOCKF">BlockF</option>
                    <option value="ASI_BLOCKG">BlockG</option>
                    <option value="ASI_BLOCKH">BlockH</option>
                    <option value="ASI_BLOCKI">BlockI</option>
                    <option value="ASI_BLOCKJ">BlockJ</option>
                    <option value="ASI_BLOCKK">BlockK</option>
                    <option value="ASI_BLOCKL">BlockL</option>
                </select>
              </div>
               <div className="col-xl-2 col-lg-12 mb-3">
                <label className="w-100 d-none d-sm-block">&nbsp;</label>
                <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </>
  )
}

export default ASIBlock